import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader';
import Message from '../components/Message';

// Landing page for the AliExpress OAuth callback redirect
// (backend/controllers/aliExpressController.js `oauthCallback` -> '/aliexpress/connected').
const AliExpressConnectedScreen = () => {
  const history = useHistory();
  const userLogin = useSelector((state) => state.user || {});
  const { userInfo } = userLogin;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!userInfo || !userInfo.isAdmin) {
      history.push('/login');
    }
  }, [history, userInfo]);

  useEffect(() => {
    if (!userInfo?.isAdmin) return;
    (async () => {
      try {
        const res = await fetch('/api/aliexpress/status', {
          headers: { Authorization: `Bearer ${userInfo?.token}` },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || 'Failed to load AliExpress status');
        setStatus(data);
      } catch (err) {
        setError(err.message || 'Unable to load AliExpress status');
      } finally {
        setLoading(false);
      }
    })();
  }, [userInfo]);

  return (
    <Container>
      <Row className='my-4'>
        <Col md={{ span: 8, offset: 2 }}>
          <Card>
            <Card.Body>
              <Card.Title>AliExpress</Card.Title>
              {loading ? (
                <Loader />
              ) : error ? (
                <Message variant='danger'>{error}</Message>
              ) : status?.connected ? (
                <Alert variant='success' className='mb-0'>
                  <Alert.Heading>✅ AliExpress account connected</Alert.Heading>
                  <p className='mb-1'>Seller ID: {status.sellerId}</p>
                  <p className='mb-0'>
                    Access expires in {Math.floor((status.expiresInSec || 0) / 60)} minute(s)
                  </p>
                </Alert>
              ) : (
                <Message variant='warning'>Not connected.</Message>
              )}
              <div className='mt-3'>
                <Link to='/admin/productlist' className='btn btn-primary'>
                  Back to Products
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AliExpressConnectedScreen;
